import { TextBrandProps, getTextStylesFromBrandStyle } from 'modules/BrandDefinition';
import * as Models from 'models';
import { resetInlineStylesOnRelation } from './resetInlineStylesOnRelation';

export const applyBrandStyleOnRelation = (
  styles: Models.TextRelationStyles,
  brandProps: TextBrandProps,
): Models.TextRelationStyles => {
  const { brandStyle, colors, fonts } = brandProps;
  const textStyles = getTextStylesFromBrandStyle(brandStyle, colors, fonts);
  const { backgroundColor, padding, verticalAlignment } = textStyles;

  return {
    ...resetInlineStylesOnRelation(styles),
    brandStyleId: brandStyle?.get('id'),
    brandStyleChanged: false,
    alignment: {
      horizontal: {},
      vertical: verticalAlignment,
    },
    backgroundColor: backgroundColor ? backgroundColor.get('name') : undefined,
    padding: padding.toJS() as Models.Padding,
  };
};
